import PropTypes from 'prop-types';
import React from 'react';

import { Text } from '../../Atoms/Text/Text';

import * as S from './Quote.styles';

export const Quote = ({ quote, author }) => {
  if (!quote) {
    return null;
  }

  return (
    <S.Quote>
      <S.ContentContainer>
        <S.Content>{quote}</S.Content>
      </S.ContentContainer>
      {author && (
        <S.AuthorContainer>
          <Text>{author}</Text>
        </S.AuthorContainer>
      )}
    </S.Quote>
  );
};

Quote.propTypes = {
  /**
   * Content of the author part containing a short description.
   */
  author: PropTypes.string,
  /**
   * Content of the quote part.
   */
  quote: PropTypes.string.isRequired,
};
